import { useTheme } from '@mui/material/styles';
import { Theme, useMediaQuery } from '@mui/material';

export const useIsBreakpointUp = (breakpoint: any): any => {
  const theme: Theme = useTheme();

  return useMediaQuery(theme.breakpoints.up(breakpoint), { noSsr: true });
};

export const useIsBreakpointDown = (breakpoint: any): any => {
  const theme: Theme = useTheme();

  return useMediaQuery(theme.breakpoints.down(breakpoint), { noSsr: true });
};

export const useIsBreakpointOnly = (breakpoint: any): any =>
  useMediaQuery((theme: Theme) => theme.breakpoints.only(breakpoint), {
    noSsr: true
  });
